import React from 'react';
import { InsightSection } from 'store/state/insightsContext';
import WidgetWrapper from 'components/widget/common/widget-wrapper';
import { InsightType } from 'utils/entities';
import { useLocale } from 'locale';
import { ILSchoolGroupsSummary } from 'store/state/selectors/insights/schools/types';
import WidgetCollapsedWrapper from 'components/widget/common/widget-collapsed-wrapper';
import SchoolList from '../school-list';

export interface ILSchoolsWidgetProps {
  data: ILSchoolGroupsSummary;
  setHoveredSchoolId: (id: string) => void;
  hoveredSchoolId: string | null;
  isCollapsed: boolean;
}

const ILSchoolsWidget: React.FC<ILSchoolsWidgetProps> = ({
  data,
  setHoveredSchoolId,
  hoveredSchoolId,
  isCollapsed,
}) => {
  const { t } = useLocale();

  if (!(data && (data.ELEMENTARY.length || data.HIGHSCHOOL.length))) return null;

  if (isCollapsed) {
    return (
      <WidgetCollapsedWrapper
        carousel={null}
        targetId={InsightSection.Schools}
        styleType={InsightType.Education}
        onlyAnalystInsight={false}
        dynamicContentData={data}
      >
        <SchoolList
          schools={data}
          hoveredSchoolId={hoveredSchoolId}
          setHoveredSchoolId={setHoveredSchoolId}
        />
      </WidgetCollapsedWrapper>
    );
  }


  return (
    <WidgetWrapper
      carousel={null}
      title={t('widgetTitle.schools')}
      targetId={InsightSection.Schools}
      styleType={InsightType.Education}
    >
      <SchoolList
        schools={data}
        hoveredSchoolId={hoveredSchoolId}
        setHoveredSchoolId={setHoveredSchoolId}
      />
    </WidgetWrapper>
  );
};

export default ILSchoolsWidget;
